"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggedIn = void 0;
const react_1 = __importStar(require("react"));
const user_context_1 = require("./user-context");
const react_router_dom_1 = require("react-router-dom");
function LoggedIn(props) {
    const { isLogedIn, reload } = react_1.useContext(user_context_1.UserContext);
    const [loaded, setLoaded] = react_1.useState(props.shouldReload ? false : true);
    react_1.useEffect(() => {
        if (props.shouldReload) {
            reload().then(() => {
                setLoaded(true);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (loaded === false) {
        // if not loaded yet, wait and show nothing
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    else {
        if (isLogedIn()) {
            // if logged in, pass through
            return react_1.default.createElement(react_1.default.Fragment, null, props.children);
        }
        else {
            // if not logged in
            if (props.redirectUrl !== undefined) {
                // if redirectUrl is specified, do the redirect
                return react_1.default.createElement(react_router_dom_1.Redirect, { to: props.redirectUrl });
            }
            else {
                // otherwise show nothing
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
        }
    }
}
exports.LoggedIn = LoggedIn;
//# sourceMappingURL=logged-in.js.map